import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { NavigationError, provideRouter, withNavigationErrorHandler } from '@angular/router';

import { routes } from './app.routes';
import { ASM_TRANSLATION_BUNDLES } from './translation-bundles';
import {
  provideSolAuthentication,
  provideSolComponents,
  provideSolDebug,
  provideSolHttpClient,
  provideSolLocale,
  provideSolNavigation,
  provideSolPreferences,
  provideSolStorage,
  provideSolTheme,
  ChunkTools,
} from '@sol/components';
import { environment } from '../environments/environment';
import { AsmLanguage } from '@asm/components-core/models/asm-language';
import { ASM_TABLE_LAYOUT_SETTINGS } from '@asm/components-table/services/asm-table-layout-settings';
import { AsmSettingsService } from '@asm/components-platform-context/services/asm-settings.service';
import { provideAsmAccessReason } from '@asm/components-platform-context/providers/provide-asm-access-reason';
import { provideAsmStepUp } from '@asm/components-platform-context/providers/provide-asm-step-up';
import { provideAsmComponents } from '@asm/components-core/providers/provide-asm-components';
import { provideAsmViews } from './providers/provide-asm-views';
import { providePlaceholderCatalogue } from '@asm/components-dashboards/services/placeholder.service';
import { providePrintPreload } from '@asm/components-reports/services/print-preload.service';
import * as packageJson from '../../package.json';
import { apps } from './apps';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withNavigationErrorHandler((e: NavigationError) => {
        ChunkTools.reloadOnChunkError(e.error);
      }),
    ),
    ...provideSolHttpClient({
      mocks: environment.HTTP_MOCKS,
    }),
    provideSolComponents(packageJson.version, (viewService, typeService) => {
      provideAsmViews(viewService, typeService);
    }),
    provideSolDebug(environment.ENV),
    ...provideSolAuthentication({
      url: environment.KEYCLOAK_URL,
      realm: environment.KEYCLOAK_REALM,
      clientId: environment.KEYCLOAK_CLIENT_ID,
    }),
    provideSolStorage(environment.APP),
    provideSolPreferences(AsmSettingsService),
    { provide: ASM_TABLE_LAYOUT_SETTINGS, useExisting: AsmSettingsService },
    provideSolTheme(environment.THEME),
    provideSolLocale(ASM_TRANSLATION_BUNDLES, [
      AsmLanguage.en,
      AsmLanguage.fr,
      AsmLanguage.de,
      AsmLanguage.es,
      AsmLanguage.ja,
    ]),
    provideSolNavigation(apps, routes, environment),
    provideAsmComponents(
      environment.ENV,
      environment.ASM_API_URL,
      environment.LICENSE_SERVICE_QUERY_URL,
      environment.LICENSE_SERVICE_COMMAND_URL,
      undefined, // auditLogServiceQueryUrl
      environment.CUSTOMER_API_URL,
      environment.SMOKE_TEST_API_URL,
      (environment as any).PENDO_API_KEY,
      environment.OUTSCAN_URL,
    ),
    provideAsmAccessReason(),
    provideAsmStepUp(),
    providePlaceholderCatalogue(),
    providePrintPreload(),
  ],
};
